import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

export type RequestType = 'death' | 'general';
export type RequestStatus = 'Pending' | 'Pending review' | 'Approved' | 'Rejected';

export interface ContactRequest {
  id: string;
  title: string;
  accountName: string;
  type: RequestType;
  status: RequestStatus;
  date: Date;
  requestId: string;
  // Death
  accountHolder?: string;
  relationship?: string;
  dateOfPassing?: Date;
  note?: string;
  documents?: { name: string; label: string; size: string }[];
  // General
  issueType?: string;
}

export interface FilterTab {
  key: 'all' | 'general' | 'death';
  label: string;
  count: number;
}


@Component({
  selector: 'app-contact-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './contact-admin.html',
styleUrls: ['./contact-admin.css']
})
export class ContactAdminComponent implements OnInit {

  // ── Session ───────────────────────────────────────────────────────────────
  currentUser = 'Akhila';
  viewingAs   = 'bharath kumar';

  // ── Avatar colours ────────────────────────────────────────────────────────
  private avatarColors = ['#7c3aed','#6366f1','#2563eb','#0891b2','#059669','#d97706','#dc2626'];

  // ── View state ────────────────────────────────────────────────────────────
  view: 'detail' | 'new-picker' | 'new-general' | 'new-death' | 'empty' = 'detail';
  selectedRequest: ContactRequest | null = null;
  newRequestType: 'general' | 'death' | null = null;

  // ── Filters ───────────────────────────────────────────────────────────────
  searchQuery = '';
  activeFilter: 'all' | 'general' | 'death' = 'all';
  filterTabs: FilterTab[] = [];
  filteredRequests: ContactRequest[] = [];
generalIssueDropdownOpen = false;

selectedIssueLabel = "Can't access account / login problem";
relationshipDropdownOpen = false;

selectedRelationshipLabel = 'Spouse / Partner';

  // ── All requests ──────────────────────────────────────────────────────────
  allRequests: ContactRequest[] = [
    // {
    //   id: '1',
    //   title: 'Report a passing',
    //   accountName: "bharath kumar's account",
    //   type: 'death',
    //   status: 'Pending review',
    //   date: new Date('2026-05-23'),
    //   requestId: 'REQ-2026-0041',
    //   accountHolder: 'bharath kumar',
    //   relationship: 'Spouse',
    //   dateOfPassing: new Date('2026-05-20'),
    //   note: 'I am his wife. He passed away on 20th May. Please help me access his documents.',
    //   documents: [
    //     { name: 'death_certificate.pdf', label: 'Death certificate', size: '1.2 MB' },
    //     { name: 'legal_id.pdf',          label: 'Additional document', size: '0.8 MB' },
    //   ],
    // },
   
    {
      id: '2',
      title: 'General support',
      accountName: "bharath kumar's account",
      type: 'general',
      status: 'Pending',
      date: new Date('2026-05-25'),
      requestId: 'REQ-2026-0042',
      accountHolder: 'bharath kumar',
      issueType: "Can't access account / login problem",
      note: "I keep getting an error saying access denied when I try to log in to view my father's account.",
    },
  ];

  // ── New request forms ─────────────────────────────────────────────────────
generalForm = {
  issueType: 'cant-access',
  accountHolder: this.viewingAs,
  description: ''
};

deathForm = {
  accountHolder: this.viewingAs,
  relationship: 'spouse',
  dateOfPassing: '',
  certFileName: '',
  notes: '',
};

  constructor(private router: Router) {}

 ngOnInit(): void {
  this.buildTabs();
  this.applyFilter();
  this.selectedRelationshipLabel = 'Spouse / Partner';

  if (this.filteredRequests.length > 0) {
    this.selectedRequest = this.filteredRequests[0];
    this.view = 'detail';
  }
}

  // ── Filter / search ───────────────────────────────────────────────────────
  buildTabs(): void {
    this.filterTabs = [
      { key: 'all',     label: 'All',     count: this.allRequests.length },
      { key: 'general', label: 'General', count: this.allRequests.filter(r => r.type === 'general').length },
      { key: 'death',   label: 'Death',   count: this.allRequests.filter(r => r.type === 'death').length },
    ];
  }

  setFilter(key: 'all' | 'general' | 'death'): void {
    this.activeFilter = key;
    this.applyFilter();
  }

  applyFilter(): void {
    let list = this.activeFilter === 'all'
      ? [...this.allRequests]
      : this.allRequests.filter(r => r.type === this.activeFilter);

    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      list = list.filter(r =>
        r.title.toLowerCase().includes(q) ||
        r.accountName.toLowerCase().includes(q)
      );
    }
    this.filteredRequests = list;
  }
  goToRequestSelection(): void {
  this.view = 'new-picker';
  this.newRequestType = null;
}

  // ── Select request ────────────────────────────────────────────────────────
  selectRequest(req: ContactRequest): void {
    this.selectedRequest = req;
    this.view = 'detail';
  }

  // ── New request flow ──────────────────────────────────────────────────────
openNewRequest(): void {
  this.generalForm.accountHolder = this.viewingAs;

  this.newRequestType = 'general';
  this.view = 'new-general';
  this.selectedRequest = null;
}

 selectNewType(type: 'general' | 'death'): void {

  if (type === 'general') {
    this.generalForm.accountHolder = this.viewingAs;
  }

  if (type === 'death') {
    this.deathForm.accountHolder = this.viewingAs;
  }

  this.newRequestType = type;
  this.view = type === 'general' ? 'new-general' : 'new-death';
}
goBack(): void {

  this.selectedRequest = this.allRequests.find(
    r => r.type === 'general'
  ) || null;

  this.view = 'detail';
}

  // ── Submit general ────────────────────────────────────────────────────────
  submitGeneralRequest(): void {
    const newReq: ContactRequest = {
      id: Date.now().toString(),
      title: 'General support',
      accountName: `${this.generalForm.accountHolder}'s account`,
      type: 'general',
      status: 'Pending',
      date: new Date(),
      requestId: `REQ-2026-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      accountHolder: this.generalForm.accountHolder,
      issueType: this.getIssueTypeLabel(this.generalForm.issueType),
      note: this.generalForm.description,
    };
    this.allRequests.unshift(newReq);
    this.buildTabs();
    this.applyFilter();
    this.selectedRequest = newReq;
    this.view = 'detail';
    this.generalForm = {
  issueType: 'cant-access',
  accountHolder: this.viewingAs,
  description: ''
};
  }

  // ── Submit death ──────────────────────────────────────────────────────────
  submitDeathRequest(): void {
    const newReq: ContactRequest = {
      id: Date.now().toString(),
      title: 'Report a passing',
      accountName: `${this.deathForm.accountHolder}'s account`,
      type: 'death',
      status: 'Pending review',
      date: new Date(),
      requestId: `REQ-2026-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      accountHolder: this.deathForm.accountHolder,
      relationship: this.getRelationshipLabel(this.deathForm.relationship),
      dateOfPassing: this.deathForm.dateOfPassing ? new Date(this.deathForm.dateOfPassing) : undefined,
      note: this.deathForm.notes,
      documents: this.deathForm.certFileName
        ? [{ name: this.deathForm.certFileName, label: 'Death certificate', size: 'N/A' }]
        : [],
    };
    this.allRequests.unshift(newReq);
    this.buildTabs();
    this.applyFilter();
    this.selectedRequest = newReq;
    this.view = 'detail';
   this.deathForm = {
  accountHolder: this.viewingAs,
  relationship: 'spouse',
  dateOfPassing: '',
  certFileName: '',
  notes: ''
};
  }

  // ── File upload handlers ──────────────────────────────────────────────────
  onCertUpload(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.deathForm.certFileName = file.name;
  }

  onAddlUpload(event: Event): void {
    // handle additional doc upload if needed
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  getAvatarColor(name: string): string {
    const idx = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0) % this.avatarColors.length;
    return this.avatarColors[idx];
  }

  private getIssueTypeLabel(key: string): string {
    const map: Record<string, string> = {
      'cant-access': "Can't access account / login problem",
      'missing-content': 'Missing content',
      'technical': 'Technical problem',
      'other': 'Other',
    };
    return map[key] || key;
  }

  private getRelationshipLabel(key: string): string {
    const map: Record<string, string> = {
      'spouse': 'Spouse / Partner',
      'child': 'Child',
      'parent': 'Parent',
      'sibling': 'Sibling',
      'executor': 'Executor',
      'other': 'Other',
    };
    return map[key] || key;
  }

  logout(): void {
    this.router.navigate(['/login']);
  }
  isGeneralFormValid(): boolean {
  return !!(
    this.generalForm.issueType &&
    this.generalForm.accountHolder.trim() &&
    this.generalForm.description.trim()
  );
}

isDeathFormValid(): boolean {
  return !!(
    this.deathForm.accountHolder.trim() &&
    this.deathForm.relationship &&
    this.deathForm.dateOfPassing &&
    this.deathForm.certFileName
  );
}
selectIssueType(value: string): void {
  this.generalForm.issueType = value;

  const labels: Record<string, string> = {
    'cant-access': "Can't access account / login problem",
    'missing-content': 'Missing content',
    'technical': 'Technical problem',
    'other': 'Other'
  };

  this.selectedIssueLabel = labels[value];
  this.generalIssueDropdownOpen = false;
}
selectRelationship(value: string): void {

  this.deathForm.relationship = value;

  const labels: Record<string, string> = {
    spouse: 'Spouse / Partner',
    child: 'Child',
    parent: 'Parent',
    sibling: 'Sibling',
    executor: 'Executor',
    other: 'Other'
  };

  this.selectedRelationshipLabel = labels[value];
  this.relationshipDropdownOpen = false;
}
}